import React from 'react';
import { TextField, FunctionField, usePermissions, useTranslate } from 'react-admin';
import CustomList from '@/components/global/list/CustomList.jsx';
import { CustomDatagridConfigurable } from '@/components/global/list/CustomDatagridConfigurable.jsx';
import CustomDatagridHeader from '@/components/global/list/CustomDatagridHeader.jsx';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer.js';
import { Box, Tooltip, Typography } from '@mui/material';

export const PromptList = () => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();
    const { openDrawer } = useDrawer();

    if (isLoading) return null;
    if (!permissions?.isAdmin) return null;

    return (
        <CustomList resource='prompt' filters={[]} sort={{ field: 'customId', order: 'ASC' }} addLastColumnShadow={true} empty={false}>
            <CustomDatagridConfigurable
                header={<CustomDatagridHeader />}
                bulkActionButtons={false}
                rowClick={id => {
                    openDrawer(id, 'prompt-show');
                    return false;
                }}
            >
                <TextField source='customId' label={translate('resources.prompt.fields.customId')} />
                <TextField source='name' label={translate('resources.prompt.fields.name')} />
                <TextField source='model' label={translate('resources.prompt.fields.model')} />
                <FunctionField
                    label={translate('resources.prompt.fields.content')}
                    source='content'
                    sortBy='content'
                    render={record => (
                        <Tooltip title={record?.content ?? ''} placement='top'>
                            <Typography className='no-bold' sx={{ maxWidth: '600px', whiteSpace: 'normal' }}>
                                {record?.content?.length > 180 ? `${record.content.slice(0, 180).trimEnd()}...` : record?.content ?? ''}
                            </Typography>
                        </Tooltip>
                    )}
                />
                <FunctionField
                    label={translate('common.options')}
                    render={record => (
                        <Box onClick={event => event.stopPropagation()}>
                            <CustomMorePopover record={record}>
                                <CustomShowModalButton
                                    onOpen={() => openDrawer(record.id, 'prompt-show')}
                                    label={translate('resources.prompt.labels.showPrompt')}
                                />
                                <CustomEditModalButton
                                    onOpen={() => openDrawer(record.id, 'prompt-edit')}
                                    label={translate('resources.prompt.labels.editPrompt')}
                                />
                            </CustomMorePopover>
                        </Box>
                    )}
                />
            </CustomDatagridConfigurable>
        </CustomList>
    );
};
